import { render, staticRenderFns } from "./drop-menu-item.vue?vue&type=template&id=36ecb23a&scoped=true"
import script from "./drop-menu-item.vue?vue&type=script&lang=js"
export * from "./drop-menu-item.vue?vue&type=script&lang=js"
import style0 from "./drop-menu-item.vue?vue&type=style&index=0&id=36ecb23a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ecb23a",
  null
  
)

export default component.exports